import {PageProps} from "@COMPONENTS/product/pages/detailPackage/common/types";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import * as style from "@COMPONENTS/style/detailpackage/promotionproduct";
import {RecommendationSlide} from "@FRAMEWORK/ui/desktop/slide";
import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import useSigninUser from "@QUERIES/account/useSigninUser";
import useGoodsRecommend from "@QUERIES/prdt/goods/useGoodsRecommend";
import {format} from "@yb/utils";
import dayjs from "dayjs";
import {useRef} from "react";
import SwiperCore from "swiper";
import {SwiperSlide} from "swiper/react";
import {Noimage} from "@yb/ui/desktop/common/Noimage";

const DetailRecommendComponent = (query: PageProps["query"]) => {
	const {evCd, dspSid} = query;
	const goodsCd = evCd.split("-")[0];
	/** 로그인 정보 */
	const useSign = useSigninUser();
	const webCustNo = useSign.data?.body.webCustNo || "";

	/** 추천상품 조회 */
	const useGoodsRecomm = useGoodsRecommend(goodsCd, dspSid, webCustNo, {enabled: !useSign.isFetching});
	const recommendList = useGoodsRecomm.data?.body || [];

	const swiperRef = useRef<SwiperCore>(null);

	return (
		<>
			{recommendList.length > 0 && (
				<style.Wrap>
					<SubTitle>추천 상품</SubTitle>
					<RecommendationSlide perView={4} spaceBetween={20} ref={swiperRef}>
						{recommendList.map((recommend, index) => {
							const {dateStart, dateEnd, goodsNm, minPrice, weblinkurl, imageThum3} = recommend;
							const start = dayjs(dateStart).format("YYYY.MM.DD");
							const end = dayjs(dateEnd).format("YYYY.MM.DD");
							const price = format.koKRFormatNumber(minPrice);
							const link = weblinkurl.replace("detailPackage.yb", "detailPackage");
							return (
								<SwiperSlide key={index}>
									<a
										href="#"
										target="_blank"
										onClick={async e => {
											e.preventDefault();
											location.href = link;
										}}
									>
										<style.SlideImg>
											<Noimage src={imageThum3 || ""} alt="상품 이미지" width="285px" height="195px" />
										</style.SlideImg>
										<style.InfoBox>
											<style.SlideTitle>{goodsNm}</style.SlideTitle>
											<style.Date>
												<em>출발기간</em>
												{start} ~ {end}
											</style.Date>
											<style.InfoBottomBlock>
												<style.Price>
													<strong>{price}</strong>원~
												</style.Price>
											</style.InfoBottomBlock>
										</style.InfoBox>
									</a>
								</SwiperSlide>
							);
						})}
					</RecommendationSlide>
				</style.Wrap>
			)}
		</>
	);
};

const DetailRecommend = (props: PageProps["query"]) => (
	<ErrorBoundary logMsg="DetailRecommend Error">
		<DetailRecommendComponent {...props} />
	</ErrorBoundary>
);

export default DetailRecommend;
